import apiClient from './apiClient'


const getSeasons = (tenant) => {
  return apiClient.get(`/${tenant}/Season`)
}

const getSeasonById = (tenant, seasonId) => {
  return apiClient.get(`/${tenant}/Season/${seasonId}`)
}

const getRelations = (tenant, id) => {
  return apiClient.get(`/${tenant}/Season/${id}/Relations`)
}

const createSeason = (tenant, season) => {
  return apiClient.post(`/${tenant}/Season`, season)
}

const updateSeason = (tenant, id, season) => {
  return apiClient.put(`/${tenant}/Season/${id}`, season)
}

const deleteSeason = (tenant, id) => {
  return apiClient.delete(`/${tenant}/Season/${id}`)
}


export default {
  getSeasons,
  getSeasonById,
  getRelations,
  createSeason,
  updateSeason,
  deleteSeason
}
